import { useRouteMatch } from 'react-router';

export const useConnect = () => {
  const { path } = useRouteMatch();
  return { path };
};
